// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;
export const STATUS = [
    { label: 'Active', value: 1, color: 'green' },
    { label: 'Deactive', value: 0, color: 'red' },
];
export const FA = [
    { label: 'Enable 2FA Auth', value: 1, color: 'green' },
    { label: 'Disable 2FA Auth', value: 0, color: 'red' },
];

